/** Status tones, DESIGN.md §2. Domain values map to a tone once, in lib/labels.ts; components only take the tone. */
export type Tone = 'positive' | 'neutral' | 'warning' | 'negative' | 'info' | 'muted'

// Literal class strings so Tailwind's scanner sees every utility.
export const toneText: Record<Tone, string> = {
  positive: 'text-positive',
  neutral: 'text-neutral',
  warning: 'text-warning',
  negative: 'text-negative',
  info: 'text-info',
  // --status-muted is too light for text (2.3:1); muted labels use secondary ink, the dot keeps the colour.
  muted: 'text-ink-2',
}

export const toneSoft: Record<Tone, string> = {
  positive: 'bg-positive-soft',
  neutral: 'bg-neutral-soft',
  warning: 'bg-warning-soft',
  negative: 'bg-negative-soft',
  info: 'bg-info-soft',
  muted: 'bg-muted-soft',
}

export const toneFill: Record<Tone, string> = {
  positive: 'bg-positive',
  neutral: 'bg-neutral',
  warning: 'bg-warning',
  negative: 'bg-negative',
  info: 'bg-info',
  muted: 'bg-muted',
}
